module.exports = __webpack_public_path__ + "img/delete-white-sm.2ea35829.svg";